module.exports = __webpack_public_path__ + "static/media/all-resources.7eb52923.svg";